<template>
  <div style="max-height: 700px; overflow-y: auto; overflow-x: hidden">
    <mf-search v-model="searchCampaign" hide-details placeholder="Busque por campanhas" />

    <select-campaigns-table
      v-model="campaigns"
      :search="searchCampaign"
      :mode="mode"
      :status="status"
      :show-message="false"
      :single-checkbox="singleCheckbox"
      default-table-sort-by="updated_at"
      :default-table-sort-desc="true"
      :include-maria-campaign="includeMariaCampaign"
      :use-campaign-frequency="useCampaignFrequency"
    />
  </div>
</template>

<script>
import SelectCampaignsTable from '@/components/select-campaigns/SelectCampaignsTable.vue'

export default {
  name: 'SelectCampaignsTableTab',
  components: {
    SelectCampaignsTable,
  },
  props: {
    useCampaignFrequency: {
      type: Boolean,
      default: false,
    },
    includeMariaCampaign: {
      type: Boolean,
      default: false,
    },
    singleCheckbox: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array,
      required: true,
    },
    mode: {
      type: Array,
      required: true,
    },
    status: {
      type: Array,
      default: () => ['ACTIVE', 'FINISHED'],
    },
  },
  data: () => ({
    searchCampaign: '',
  }),
  computed: {
    campaigns: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
